'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jsQR = require('jsqr');

var ConvertBase64 = function () {
    function ConvertBase64() {
        (0, _classCallCheck3.default)(this, ConvertBase64);

        this.canvas = document.createElement("canvas");
        this.context = this.canvas.getContext("2d");
        this.image = new Image();
    }

    (0, _createClass3.default)(ConvertBase64, [{
        key: 'getImageData',
        value: function getImageData(base64) {
            var _this = this;

            return new _promise2.default(function (resolve, reject) {
                if (!base64) {
                    return reject(new Error('the argument is invalid'));
                }
                var image = _this.image;
                var canvas = _this.canvas;
                var context = _this.context;
                image.addEventListener("load", function () {
                    canvas.width = image.width;
                    canvas.height = image.height;
                    context.drawImage(image, 0, 0, canvas.width, canvas.height);
                    var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
                    return resolve(imageData);
                }, false);
                image.src = base64;
            });
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this.image = null;
            this.canvas = null;
        }
    }]);
    return ConvertBase64;
}();

/**
 * decode base64
 * @param {string} base64
 */


var convertImage = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(base64) {
        var convert, data, imageData, code;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        convert = new ConvertBase64();
                        data = void 0;
                        _context.prev = 2;
                        _context.next = 5;
                        return convert.getImageData(base64);

                    case 5:
                        imageData = _context.sent;
                        code = jsQR(imageData.data, imageData.width, imageData.height);

                        data = code.data.trim();
                        _context.next = 13;
                        break;

                    case 10:
                        _context.prev = 10;
                        _context.t0 = _context['catch'](2);

                        data = null;

                    case 13:
                        convert.destroy();
                        return _context.abrupt('return', data);

                    case 15:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined, [[2, 10]]);
    }));

    return function convertImage(_x) {
        return _ref.apply(this, arguments);
    };
}();

module.exports = convertImage;